import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { icon, validColor, invalidColor, noDataColor } from '../../../utils/styleConst';

const ListLegend = styled.ul`
  padding: 2px 10px 10px 6px;
  background: white;
  position: absolute;
  bottom: 30px;
  left: 10px;
  box-shadow: 0px 1px 4px -1px rgba(0, 0, 0, 0.3);
  font-size: 14px;
  border-radius: 2px;

  li {
    float: left;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }

    svg {
      transform: translate(0, 5px);
    }
  }
  
`;

const IconSvg = ({ color }) => (
  <svg height="24" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={icon(color).fillColor}
      stroke={icon().strokeColor}
      strokeOpacity={icon().strokeOpacity}
      strok-width={icon().strokeWeight}
      d={icon().path}
    />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

IconSvg.propTypes = {
  color: PropTypes.string.isRequired,
};

const Legend = ({ hasUnavailableData }) => (
  <ListLegend className="clearfix">
    <li><IconSvg color={validColor} /> Libre</li>
    <li><IconSvg color={invalidColor} /> Complet</li>
    {hasUnavailableData && (
      <li><IconSvg color={noDataColor} /> Données indisponibles</li>
    )}
  </ListLegend>
);

Legend.propTypes = {
  hasUnavailableData: PropTypes.bool.isRequired,
};

export default Legend;




// WEBPACK FOOTER //
// src/components/googleMap/Legend/Legend.jsx